/* eslint-disable import/named */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SidebarContent from '../components/Sidebar/SidebarContent';

import { isManagerSelector, isAdminSelector, pathnameSelector } from '../selectors';
import { toggleMenuDesktop, openUsersModal } from '../actions/entry';

const mapStateToProps = (state) => {
  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);
  const path = pathnameSelector(state);

  return {
    isAdmin,
    isManager,
    path,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onUsers: openUsersModal,
      toggleMenu: toggleMenuDesktop,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContent);
